module.exports = __webpack_public_path__ + "0ad4828a4b691b9e6e515642144a5956.svg";